module.exports = ".section{font-weight:bold}\n"